import {useState} from 'react';
import { Outlet, Link } from "react-router-dom";
import '../css/layout.css';
import { Sidebar, Menu, MenuItem,SubMenu } from 'react-pro-sidebar';
import {Image} from '../img';
import { connect, } from "react-redux";
import { useDispatch } from 'react-redux'
import Navbar from '../Nav/Navbar';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom'

const menuItemObj=[
    { label:'How To Access OLE',active:'/how-to-access-ole'},
    { label:'Dashboard',active:'/dashboard'},
    { label:'Course Page',active:'/course-page'},
    { label:'Taking Attendance',active:'/taking-attendance'},
    { label:'Assignment',active:'/assignment'},
    { label:'Zoom Recording',active:'/zoom-recording'},
    { label:'Teaching Tools',active:'/teaching-tools'},
]
const Layout=(props)=>{
    const dispatch=useDispatch();
     const location = useLocation()
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search)
    return(
        <>
            <div style={{display: 'flex'}}>
                <div className={`customSideMenu ${(props.commonInfo.menuShow?'menu-slide-in':'menu-slide-out')}`} 
                    style={{position:'absolute',height: "100vh",zIndex:3
                    
                    }}>
                    <Sidebar defaultCollapsed={false}  width={'320px'} height={'100%'} closeOnClick={true} 
                    rootStyles={{
                        height:'100%',
                        opacity:1,
                        backgroundColor: 'rgb(249, 249, 249, 1)',
                    }}>
                        <div style={{height:'80px',marginTop:'10px'}}>
                            <Link to={'/'} onClick={()=>{dispatch({type:'COMMON_SET_MENUSHOW',payload:false})}}>
                                <img src={Image.Home} className={'sideMenuHomeBtn'}  style={{'marginLeft':'10px'}}/>
                            </Link>
                            <img className={'sideMenuCancelBtn'} src={Image.Cancel} style={{float:'right'}} onClick={()=>{
                                dispatch({type:'COMMON_SET_MENUSHOW',payload:false})
                            }}/>
                        </div>
                        <Menu rootStyles={{
                            'border-top': '#F26F12 .5px solid',
                            'fontFamily':'ITCFranklinGothicBookCondensed',
                            'fontSize':'23px'
                        }}>
                            {
                                menuItemObj.map((item,i)=>{
                                    
                                    //react pro sidebar -> menuitem active  css 
                                    return (
                                        <MenuItem active={location.pathname === item.active} component={<Link to={item.active} onClick ={()=>{dispatch({type:'COMMON_SET_MENUSHOW',payload:false})}}/>}>
                                                                            
                                            <span style={{marginRight:'10px',color:'#FCAB71',marginLeft:'20px'}}> {(i+1)} </span> 
                                            <span  className={'sideMenuButtonText'}>{item.label}</span>
                                        </MenuItem>
                                    )
                                })
                            }
                        </Menu>
                    </Sidebar>
                </div>
            {/* <Navbar /> */}
            <Outlet />
            </div>
        </>
    );
}


const mapStateToProps =(state)=> {

    const {userInfo,commonInfo}=state;
    return {
        userInfo,
        commonInfo
    }
}

const mapReduxDispatchToProps=(dispatch)=>{
    return {
        dispatch,
        setMenuShow:(bool)=>dispatch({type:'COMMON_SET_MENUSHOW',payload:{bool}}),
        
        
    }
}


export default connect(mapStateToProps,mapReduxDispatchToProps)(Layout);
